/**
 * Overview Details Manager
 * Manages the open/closed state of details element in camp overview
 * based on viewport width
 */

;(function () {
  'use strict'

  const BREAKPOINT = 1400 // pixels

  /**
   * Initialize the overview details functionality
   */
  function initOverviewDetails() {
    const detailsElement = document.querySelector(
      '.rd-camp-overview__read-more-container'
    )

    if (!detailsElement) {
      return
    }

    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth

    // Remove 'open' attribute if viewport is less than breakpoint
    if (viewportWidth < BREAKPOINT) {
      detailsElement.removeAttribute('open')
    }
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOverviewDetails)
  } else {
    // DOM is already loaded
    initOverviewDetails()
  }
})()
